module.exports = __webpack_public_path__ + "static/media/vons.b777dc19.svg";